module.exports = __webpack_public_path__ + "img/legales.7797d191.svg";